
import React, { useEffect, useState } from "react";
import { BiBell, BiUserCircle } from "react-icons/bi";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { getAuth, signOut } from "firebase/auth";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Dropdown from "react-bootstrap/Dropdown";
import { loadLanguageLabels, loadLanguages, selectCurrentLanguage, selectLanguages, setCurrentLanguage } from "../store/reducers/languageReducer";
import { useSelector } from "react-redux";
import { categoriesApi } from "../store/actions/campaign";
import { getSiblings, slideToggle, slideUp, getClosest, isLogin, translate, truncateText, profileimgError } from "../utils/index";
import { logoutUser, selectUser } from "../store/reducers/userReducer";
import SignInModal from "./SignInModal";
import { toast } from "react-toastify";
import { webSettingsData } from "../store/reducers/websettingsReducer";
import { counterData, loadNotification, loaduserNotification } from "../store/reducers/notificationbadgeReducer";
import MobilesideBar from "./MobilesideBar";
import { settingsData } from "../store/reducers/settingsReducer";
import { AiOutlineSearch, AiOutlineHeart, AiFillHome } from "react-icons/ai";
import "./pt-home.css";
import { SetSearchPopUp } from "../store/stateSlice/clickActionSlice";
import { store } from "../store/store";
import RagisterModalTwo from "./RegisterModalTwo";
// Show site name + tagline next to the logo. Set to false if the logo image already contains the name.
const SHOW_BRAND_TEXT = true;
const BRAND_TAGLINE = "राष्ट्र • धर्म • समाज • सेवा";

const Newsbar = () => {

    const userData = useSelector(selectUser);

    const auth = getAuth();
    const [Data, setData] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalShow1, setModalShow1] = useState(false);
    const [islogout, setIsLogout] = useState(false); // eslint-disable-next-line
    const [islogout1, setIsLogout1] = useState(false); // eslint-disable-next-line
    const [isloginloading, setisloginloading] = useState(true); // eslint-disable-next-line
    const [profileModal, setProfileModal] = useState(false);
    const [isuserRole] = useState(false);

    const navigate = useNavigate();

    const counterBadgeData = useSelector(counterData);

    const languagesData = useSelector(selectLanguages);

    const currentLanguage = useSelector(selectCurrentLanguage);

    const websettings = useSelector(webSettingsData);

    const settings = useSelector(settingsData);


    useEffect(() => {
        // get categories
        categoriesApi(
            "0",
            "16",
            currentLanguage.id,
            (response) => {
                setData(response.data);
            },
            (error) => {
                if (error === "No Data Found") {
                    setData("");
                }
            }
        );


        // language laod
        loadLanguages(
            (response) => {
                if (currentLanguage.code == null) {// eslint-disable-next-line
                    let index = response && response.data.filter((data) => {
                        if (data.code === settings.default_language[0].code) {
                            return { code: data.code, name: data.language, id: data.id };
                        }
                    });

                    setCurrentLanguage(index[0].language, index[0].code, index[0].id);
                }
            },
            (error) => {
                console.log(error);
            }
        );

        // eslint-disable-next-line
    }, [currentLanguage]);

    // language change
    const languageChange = (name, code, id) => {
        loadLanguageLabels(code);
        setCurrentLanguage(name, code, id);
    };

    useEffect(() => {
        if (userData.data !== null) {
            setIsLogout(true);
            setIsLogout1(true);
            setisloginloading(false);
        } else {
            setIsLogout(false);
            setIsLogout1(false);
            setisloginloading(true);
        } // eslint-disable-next-line
    }, []);

    // user notification
    const getusernotification = () => {
        loaduserNotification(
            "0",
            "10",
            (response) => {
            },
            (error) => {
            }
        );
    };

    const getnotification = () => {
        loadNotification(
            "0",
            "20",
            (response) => {
            },
            (error) => {
            }
        );
    };


    useEffect(() => {
        // Make API calls here based on route change
        if (window.location.pathname === '/') {
            getusernotification();
        } else if (window.location.pathname === '/notification' || window.location.pathname === '/persnol-notification') {
            getusernotification();
        } else if (window.location.pathname === '/news-notification') {
            getnotification();
        }// eslint-disable-next-line
    }, [window.location.pathname, isLogin()]);

    const logout = () => {
        handleClose();

        confirmAlert({
            title: "Logout",
            message: "Are you sure to do this.",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        signOut(auth)
                            .then(() => {
                                logoutUser();
                                setIsLogout(false);
                                setIsLogout1(false);
                                navigate("/");
                            })
                            .catch((error) => {
                                toast.error(error);
                                // An error happened.
                            });
                    },
                },
                {
                    label: "No",
                    onClick: () => { },
                },
            ],
        });
    };

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const onClickHandler = (e) => {
        const target = e.currentTarget;
        const parentEl = target.parentElement;
        if (parentEl?.classList.contains("menu-toggle") || target.classList.contains("menu-toggle")) {
            const element = target.classList.contains("icon") ? parentEl : target;
            const parent = getClosest(element, "li");
            const childNodes = parent.childNodes;
            const parentSiblings = getSiblings(parent);
            parentSiblings.forEach((sibling) => {
                const sibChildNodes = sibling.childNodes;
                sibChildNodes.forEach((child) => {
                    if (child.nodeName === "UL") {
                        slideUp(child, 1000);
                    }
                });
            });
            childNodes.forEach((child) => {
                if (child.nodeName === "UL") {
                    slideToggle(child, 1000);
                }
            });
        }
    };

    let userName = "";

    const checkUserData = (userData) => {
        if (userData.data && userData.data.name !== "") {
            return (userName = userData.data.name);
        } else if (userData.data && userData.data.email !== "") {
            return (userName = userData.data.email);
        } else if (userData.data && (userData.data.mobile !== null || userData.data.mobile !== "")) {
            return (userName = userData.data.mobile);
        }
    };


    // set rtl
    const selectedLang = languagesData && languagesData.find(lang => lang.code === currentLanguage.code);
    useEffect(() => {
        if (selectedLang && selectedLang.isRTL === "1") {
            document.documentElement.dir = "rtl";
            document.documentElement.lang = `${selectedLang && selectedLang.code}`;
        } else {
            document.documentElement.dir = "ltr";
            document.documentElement.lang = `${selectedLang && selectedLang.code}`;
        }
    }, [selectedLang]);

    const searchPopUp = useSelector((state) => state.clickAction.searchPopUp);
    const actionSearch = () => {
        store.dispatch(SetSearchPopUp(!searchPopUp));
    };

    // PT-SEARCH-FIX v2: cursor goes straight into the search box (waits until the popup is really visible); Esc closes it
    useEffect(() => {
        if (!searchPopUp) return undefined;
        let tries = 0;
        const focusTimer = setInterval(() => {
            tries += 1;
            const input = document.querySelector("#td-search-popup input");
            const box = document.querySelector("#td-search-popup .search-form");
            if (input && box && getComputedStyle(box).visibility === "visible") {
                input.focus();
                if (document.activeElement === input) clearInterval(focusTimer);
            }
            if (tries > 40) clearInterval(focusTimer);
        }, 50);
        const onKey = (e) => {
            if (e.key === "Escape") store.dispatch(SetSearchPopUp(false));
        };
        document.addEventListener("keydown", onKey);
        return () => {
            clearInterval(focusTimer);
            document.removeEventListener("keydown", onKey);
        };
    }, [searchPopUp]);


    // PT-NEWSBAR-FIX v1: the old "user role" API call was removed. Website news posting is off
    // (staff use the admin panel), so it only made an extra request on every page load.

    const navClass = ({ isActive }) => `pt-nav-link${isActive ? " active" : ""}`;

    const navItems = [
        { to: "/", label: translate("home"), end: true },
        settings && settings.breaking_news_mode === "1" ? { to: "/breaking-news-view", label: translate("breakingnews") } : null,
        settings && settings.live_streaming_mode === "1" ? { to: "/live-news", label: translate("livenews") } : null,
        { to: "/video-news-view/27", label: "Speeches" },
        { to: "/view-all/24", label: "Newspaper Coverage" },
        { to: "/view-all/29", label: "Latest News" },
        { to: "/gallery-image", label: "Gallery" },
        { to: "/more-pages", label: translate("More Pages") },
    ].filter(Boolean);

    return (
        <>
            <header className="pt-header">
                <div className="container">
                    <div className="pt-header-top">
                        <NavLink to="/" end className="pt-brand" aria-label="Home">
                            {websettings && websettings.web_header_logo ? (
                                <img className="pt-brand-logo" src={websettings.web_header_logo} alt={(websettings && websettings.web_name) || "logo"} />
                            ) : null}
                            {SHOW_BRAND_TEXT && websettings && websettings.web_name ? (
                                <span className="pt-brand-text">
                                    <span className="pt-brand-name">{websettings.web_name}</span>
                                    <span className="pt-brand-tag">{BRAND_TAGLINE}</span>
                                </span>
                            ) : null}
                        </NavLink>

                        <button type="button" className="pt-header-search" onClick={actionSearch} aria-label="Search">
                            <span className="pt-header-search-text">Search news, speech, gallery...</span>
                            <span className="pt-header-search-btn" aria-hidden="true">
                                <AiOutlineSearch size={20} />
                            </span>
                        </button>

                        <div className="pt-header-actions">
                            {isLogin() ? (
                                <Link to="/notification" className="pt-icon-btn" aria-label="Notifications">
                                    <BiBell size={22} />
                                    {counterBadgeData && counterBadgeData.counter ? (
                                        <span className="noti_badge_data">{counterBadgeData.counter}</span>
                                    ) : null}
                                </Link>
                            ) : null}

                            {isLogin() && checkUserData(userData) ? (
                                <Dropdown align="end">
                                    <Dropdown.Toggle className="pt-btn pt-btn--user">
                                        <img className="profile_photo" src={userData.data && userData.data.profile} onError={profileimgError} alt="profile" />
                                        {truncateText(userName, 10)}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="pt-user-menu">
                                        <Dropdown.Item as={Link} to="/bookmark">{translate("bookmark")}</Dropdown.Item>
                                        <Dropdown.Item as={Link} to="/user-based-categories">{translate("managePreferences")}</Dropdown.Item>
                                        {isuserRole ? (
                                            <>
                                                <Dropdown.Item as={Link} to="/create-news">{translate("createNewsLbl")}</Dropdown.Item>
                                                <Dropdown.Item as={Link} to="/manage-news">{translate("manageNewsLbl")}</Dropdown.Item>
                                            </>
                                        ) : null}
                                        <Dropdown.Item as={Link} to="/profile-update">{translate("update-profile")}</Dropdown.Item>
                                        <Dropdown.Divider />
                                        <Dropdown.Item onClick={logout}>{translate("logout")}</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            ) : (
                                <>
                                    <Button onClick={() => setModalShow(true)} className="pt-btn" type="button">
                                        <BiUserCircle size={20} aria-hidden="true" />
                                        {translate("Login")}
                                    </Button>
                                    <Button onClick={() => setModalShow1(true)} className="pt-btn" type="button">
                                        <BiUserCircle size={20} aria-hidden="true" />
                                        {translate("Register")}
                                    </Button>
                                </>
                            )}
                            <Link to="/donationform" className="pt-btn pt-btn--solid">
                                <AiOutlineHeart size={20} aria-hidden="true" />
                                {translate("Donate")}
                            </Link>
                        </div>

                        <div className="hamburger-manu">
                            {["end"].map((placement, idx) => (
                                <MobilesideBar key={idx} setRegisterShow={setModalShow1} isuserRole={isuserRole} languageChange={languageChange} placement={placement} name={placement} logout={logout} onClickHandler={onClickHandler} Data={Data} modalShow={modalShow} setModalShow={setModalShow} islogout={islogout} setIsLogout={setIsLogout} handleShow={handleShow} show={show} handleClose={handleClose} ProfileModal={setProfileModal} />
                            ))}
                        </div>
                    </div>
                </div>

                <nav className="pt-header-nav" aria-label="Main">
                    <div className="container">
                        <ul>
                            {navItems.map((item) => (
                                <li key={item.to}>
                                    <NavLink to={item.to} end={item.end} className={navClass}>
                                        {item.end ? <AiFillHome size={16} aria-hidden="true" /> : null}
                                        {item.label}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </div>
                </nav>

                <SignInModal setIsLogout={setIsLogout} setisloginloading={setisloginloading} show={modalShow} setLoginModalShow={setModalShow} onHide={() => setModalShow(false)} />
                <RagisterModalTwo setIsLogout={setIsLogout1} setisloginloading={setisloginloading} show={modalShow1} setLoginModalShow={setModalShow} onHide={() => setModalShow1(false)} />
            </header>
        </>
    );
};

export default Newsbar;
